module.exports = __webpack_public_path__ + "img/vegetable-burdock-350x184.fc56af85.jpg";